import { ActivityFilterKey } from '@gripp/shared-logic';
import { ActivityFilter, DropDownView, FilterType } from '@gripp/shared-ui';
import { View } from 'react-native';

type TypesFilterMenuProps = {
  onFilterOpen: () => void;
  onFilterClose: () => void;
  isOpened: boolean;
  anchorRef: React.RefObject<View>;
  type: FilterType;
  filterKey?: ActivityFilterKey;
};

export const TypesFilterMenu = ({
  onFilterClose,
  onFilterOpen,
  isOpened,
  anchorRef,
  type,
  filterKey,
}: TypesFilterMenuProps) => {
  return (
    <DropDownView
      anchorRef={anchorRef}
      isVisible={isOpened}
      onDismiss={onFilterClose}
    >
      {filterKey && (
        <ActivityFilter
          goBack={onFilterClose}
          filterKey={filterKey}
          type={type}
        />
      )}
    </DropDownView>
  );
};
